import {ErrorHandler} from "./Components/ErrorHandler";
import {successAlert} from "./Components/jquery-confirm";
import {OoredooIcon} from "./Components/OoredooIcon";
import {btnLoading} from "./Components/Helpers";
import {checkValidFields} from "./CustomerFormHelpers";

(($) => {
    $(document).ready(function () {
        const form = $('.ods-purchase-form');

        if (!form.length) {
            return;
        }


        // $.each(form.find('input.ods-form-control'), function (idx, input) {
        //     input = $(input);
        //     const wrapper = $('<div class="ods-form-control__wrapper ods-form-control" contenteditable="true" style="" >');
        //     input.parent().append(wrapper);
        //     wrapper.css({
        //
        //     });
        //     input.css({
        //
        //     });
        //     wrapper.on('keyup', function (e) {
        //         input.val($(this).text().trim());
        //     });
        // })

        form.on('click', '.terms-and-conditions-btn', function (e) {
            e.preventDefault();
            const content = $(this).closest('.terms-and-conditions-wrapper').find('.terms-and-conditions-content');
            if (!content.length) {
                return false;
            }
            const btn = $(this);
            let isAccepted = false;

            const _alert = successAlert(content.html(), {
                columnClass: 'column is-10 ',
                iconHtml: OoredooIcon('icon-Icon-161'),
                closeIcon: false,
                backgroundDismiss: true,
                // escapeKey: true,
                buttons: {
                    accept: {
                        text: 'الموافقة على الشروط',
                        action: function () {
                            isAccepted = true;
                            btn.find('#i_accept_terms')[0].checked = true;
                            checkValidFields(form)
                        }
                    }
                },
                onClose: function () {
                    btn.find('#i_accept_terms')[0].checked = isAccepted;
                    checkValidFields(form)
                },

            })
        });

        form.on('submit', function (e) {
            e.preventDefault();
            const this_form = this;
            if (this_form.is_submitting) {
                return false;
            }
            this_form.is_submitting = true;

            btnLoading(form.find('.btn-submit'), true);
            $.ajax({
                url: $(this).attr('action'),
                method: 'POST',
                dataType: 'json',
                data: form.serialize(),

                beforeSend: function (request) {
                    form.find('.alert').remove();
                    form.find('.input-feedback').remove();
                    form.find('.ods-form-group__feedback').remove();
                    form.find('.has-error').removeClass('has-error');
                    form.find('.ods-form-group--has-error').removeClass('ods-form-group--has-error');

                    request.setRequestHeader('Xsrf-K', window.application.requestToken.key);
                    request.setRequestHeader('Xsrf-V', window.application.requestToken.value);
                },
                success: function (response) {
                    this_form.is_submitting = false;
                    // console.log('response',response)
                    if (typeof response.redirect_url !== 'undefined') {
                        window.location.href = response.redirect_url
                    } else {
                        successAlert(response.message, {
                            onClose: function () {
                                if (typeof response.redirect_url_on_close !== 'undefined' && typeof response.redirect_url_on_close === 'string' && response.redirect_url_on_close.length) {
                                    window.location.href = response.redirect_url_on_close;
                                }
                            },
                            
                            buttons: {
                                close: {
                                    text: application.oss.translations.oss_form.close,
                                    btnClass: 'btn btn-danger',
                                    action: function () {
                                        if (typeof response.redirect_url_on_close !== 'undefined' && typeof response.redirect_url_on_close === 'string' && response.redirect_url_on_close.length) {
                                            window.location.href = response.redirect_url_on_close;
                                        }
                                    }
                                }
                            }
                        });
                    }

                    btnLoading(form.find('.btn-submit'), false);

                    if (form.find('[name="recaptcha"]').length && typeof window.grecaptcha !== 'undefined') {
                        window.grecaptcha.reset();
                    }

                },
                error: function (xhr) {
                    this_form.is_submitting = false;
                    ErrorHandler(xhr, form);

                    btnLoading(form.find('.btn-submit'), false);
                },

            });


        });

        form.on('change', function (e) {
            setTimeout(function () {
                checkValidFields(form);
            }, 100)
        })
    });
})(jQuery);
